import React from "react";

export const tabCountReachedMessage = (<>
  <strong>Maximum tab count reached. </strong>
  <div>To create a new tab or load a saved view, close one of your existing tabs.</div>
</>);
